import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";
import { useFieldContext } from "../form-context";

export function PhoneField({ label }: { label: string }) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;
  return (
    <Field>
      <FieldLabel>{label}</FieldLabel>
      <Input
        id={field.name}
        type="tel"
        name={field.name}
        value={field.state.value}
        aria-invalid={isInvalid}
        onChange={(e) => {
          const cleaned = e.target.value.replace(/[^0-9+]/g, "");
          field.handleChange(cleaned);
        }}
      />
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
